import React from 'react';
import { connect } from 'react-redux';
import AdminShell, { Icon, Who } from './AdminShell';
import DataTable from './DataTable';
import { Modal } from './Overlay';
import { Field } from './Form';

/*
 * Admin users — layar `admins` paket client.
 *
 * PROTOTIPE MEMINTA TIGA HAL YANG TIDAK ADA DATANYA. Kolom "Last active"
 * tidak punya sumber: tidak ada kolom login terakhir di AdminUser, dan tidak
 * ada tabel sesi. Kolom "Status" juga tidak — akun admin tidak bisa
 * dinonaktifkan, hanya dihapus. Dan "Invite admin" tidak bisa mengirim
 * undangan: tidak ada alur undangan, tidak ada pemulihan sandi, dan email
 * platform ini sedang mati sama sekali. Yang bisa dilakukan adalah membuat
 * akun beserta sandinya lalu menyampaikan sandinya lewat jalur lain, jadi
 * tombolnya berbunyi apa adanya.
 *
 * SUPER ADMIN IKUT DITAMPILKAN. Layar klasik menyaringnya keluar, sehingga
 * akun dengan kuasa terbesar justru tidak terlihat di halaman yang gunanya
 * memperlihatkan siapa saja yang punya akses.
 *
 * PERAN TIDAK MENJAGA APA PUN DI SISI SERVER. Token admin cuma berisi id,
 * email dan `admin: true` — tidak ada peran, tidak ada hak akses. Setiap
 * mutation hanya bertanya "apakah kamu admin". Hak akses per peran cuma
 * menyembunyikan tautan di menu dashboard LAMA; siapa pun yang sudah masuk
 * tetap bisa memanggil mutation apa pun secara langsung. Halaman ini
 * mengatakannya, karena kolom peran yang tidak menjelaskan itu memberi rasa
 * aman yang keliru.
 */

const gql = (query, variables) => fetch('/graphql', {
  method: 'post',
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
  body: JSON.stringify({ query, variables }),
  credentials: 'include'
}).then(r => r.json());

const Q = `query {
  getAllAdminUsers(includeSuperAdmins: true) {
    status errorMessage
    results {
      id email isSuperAdmin roleId createdAt updatedAt isYou privilegeCount
      adminRole { id name }
    }
  }
  getAllAdminRoles { status results { id name description } }
}`;

const M_SAVE = `mutation ($id: String, $email: String!, $password: String, $roleId: Int!) {
  createAdminUser(id: $id, email: $email, password: $password, roleId: $roleId) {
    status errorMessage
  }
}`;

const M_DELETE = `mutation ($id: String!) {
  deleteAdminUser(id: $id) { status errorMessage }
}`;

const ok = res => res && Number(res.status) === 200;

const when = v => {
  if (!v) return '—';
  const d = new Date(Number.isNaN(Number(v)) ? v : Number(v));
  return Number.isNaN(d.getTime()) ? '—' : d.toISOString().slice(0, 10);
};

class AdminUsers extends React.Component {
  state = {
    rows: [], roles: [], me: null, search: '',
    loading: true, error: null, notice: null,
    editing: null, removing: null, busy: false,
    // Galat formulir baru muncul setelah orangnya mencoba menyimpan. Formulir
    // kosong yang langsung memerah membaca seperti kesalahan yang belum dibuat.
    tried: false,
    form: { email: '', password: '', roleId: '' }
  };

  componentDidMount() { this.load(); }

  isArabic = () => String(this.props.currentLocale || '').startsWith('ar');
  tx = (en, ar) => this.isArabic() ? ar : en;

  errorText = (message, fallbackEn, fallbackAr) => {
    if (!this.isArabic()) return message || fallbackEn;
    const value = String(message || '').toLowerCase();
    if (value.includes('already exist')) return 'يوجد حساب إداري بهذا البريد بالفعل.';
    if (value.includes('own role')) return 'لا يمكنك تغيير دورك بنفسك. اطلب من مسؤول آخر تغييره.';
    if (value.includes('super admin')) return 'يمكن للمسؤول الأعلى فقط تعديل مسؤول أعلى آخر.';
    if (value.includes('own account')) return 'لا يمكنك حذف حسابك بنفسك.';
    if (value.includes('last admin')) return 'هذا آخر حساب إداري، وحذفه سيمنع الجميع من الدخول.';
    if (value.includes('password')) return 'يجب ألا تقل كلمة المرور عن 8 أحرف.';
    if (value.includes('email')) return 'أدخل عنوان بريد إلكتروني صالحاً.';
    return fallbackAr;
  };

  load = async () => {
    this.setState({ loading: true, error: null });
    const json = await gql(Q, {}).catch(() => null);
    const d = json && json.data;
    const users = d && d.getAllAdminUsers;
    const roles = d && d.getAllAdminRoles;
    if (!ok(users) || !ok(roles)) {
      this.setState({ loading: false, error: this.isArabic()
        ? 'تعذّر تحميل حسابات المسؤولين وأدوارهم.'
        : (users && users.errorMessage) || (roles && roles.errorMessage) || 'Could not load the admin accounts and roles.' });
      return;
    }
    const rows = users.results || [];
    this.setState({
      rows,
      roles: roles.results || [],
      me: rows.find(row => row.isYou) || null,
      loading: false
    });
  };

  openNew = () => this.setState({
    editing: { id: null },
    form: { email: '', password: '', roleId: '' },
    tried: false, notice: null
  });

  openEdit = r => this.setState({
    editing: r,
    // Sandi selalu mulai kosong: nilai lamanya tidak pernah dikirim ke sini,
    // dan kosong berarti "biarkan seperti sekarang".
    form: { email: r.email || '', password: '', roleId: r.roleId ? String(r.roleId) : '' },
    tried: false, notice: null
  });

  set = (k, v) => this.setState(st => ({ form: { ...st.form, [k]: v } }));

  formError() {
    const { editing, form } = this.state;
    const email = String(form.email || '').trim();
    if (!email) return this.tx('An email address is required.', 'البريد الإلكتروني مطلوب.');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return this.tx('That does not look like an email address.', 'أدخل عنوان بريد إلكتروني صالحاً.');
    if (!form.roleId) return this.tx('Pick a role.', 'اختر دوراً.');
    const pw = String(form.password || '');
    // Sandi wajib saat membuat, opsional saat mengubah.
    if (!editing.id && pw.length < 8) return this.tx('A new admin needs a password of at least 8 characters.', 'يحتاج المسؤول الجديد إلى كلمة مرور من 8 أحرف على الأقل.');
    if (editing.id && pw && pw.length < 8) return this.tx('The new password must be at least 8 characters.', 'يجب ألا تقل كلمة المرور الجديدة عن 8 أحرف.');
    return null;
  }

  save = async () => {
    if (this.state.busy) return;
    const err = this.formError();
    if (err) { this.setState({ tried: true }); return; }

    const { editing, form } = this.state;
    this.setState({ busy: true });
    const json = await gql(M_SAVE, {
      id: editing.id || null,
      email: String(form.email).trim(),
      password: form.password ? String(form.password) : null,
      roleId: Number(form.roleId)
    }).catch(() => null);
    const res = json && json.data && json.data.createAdminUser;
    this.setState({ busy: false });

    if (!ok(res)) {
      this.setState({ notice: { tone: 'danger', text: this.errorText(
        res && res.errorMessage, 'Could not save the account.', 'تعذّر حفظ الحساب.'
      ) } });
      return;
    }

    const madeNew = !editing.id;
    const gavePassword = !!form.password;
    this.setState({ editing: null });
    await this.load();
    this.setState({
      notice: {
        tone: 'info',
        text: madeNew
          ? this.tx(`Account created for ${String(form.email).trim()}. Give them the password yourself — nothing was emailed, and there is no password reset in this system.`,
            `تم إنشاء حساب ${String(form.email).trim()}. سلّمه كلمة المرور بنفسك؛ لم يُرسل بريد ولا توجد استعادة لكلمة المرور في النظام.`)
          : (gavePassword
            ? this.tx('Account updated. The new password is active immediately; their existing session keeps working until it expires.', 'تم تحديث الحساب. تعمل كلمة المرور الجديدة فوراً، وتستمر الجلسة الحالية حتى تنتهي.')
            : this.tx('Account updated.', 'تم تحديث الحساب.'))
      }
    });
  };

  remove = async () => {
    if (this.state.busy) return;
    const { removing } = this.state;
    this.setState({ busy: true });
    const json = await gql(M_DELETE, { id: String(removing.id) }).catch(() => null);
    const res = json && json.data && json.data.deleteAdminUser;
    this.setState({ busy: false });

    if (!ok(res)) {
      this.setState({
        removing: null,
        notice: { tone: 'danger', text: this.errorText(
          res && res.errorMessage, 'Could not remove the account.', 'تعذّر حذف الحساب.'
        ) }
      });
      return;
    }

    this.setState({ removing: null });
    await this.load();
    this.setState({ notice: { tone: 'info', text: this.tx(
      `${removing.email} no longer has access.`, `لم يعد لدى ${removing.email} صلاحية الدخول.`
    ) } });
  };

  columns() {
    const { me } = this.state;
    const iAmSuper = !!(me && me.isSuperAdmin);

    return [
      {
        key: 'email', label: this.tx('Admin', 'المسؤول'), sortable: true,
        render: r => (
          <span style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <Who name={r.email} sub={r.isYou ? this.tx('This is you', 'هذا حسابك') : null} />
          </span>
        )
      },
      {
        key: 'role', label: this.tx('Role', 'الدور'), sortable: true,
        sortValue: r => (r.adminRole && r.adminRole.name) || '',
        render: r => (
          // ponytail: satu lencana saja. Bendera isSuperAdmin menang atas nama
          // peran — peran bernama "Super Admin" dulu tampil berdampingan dengan
          // lencana bendera, dan dua tulisan sama persis terbaca seperti bug.
          <span style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
            {r.isSuperAdmin
              ? <span className="tag amber" title={this.tx(
                `Set by the isSuperAdmin column, not by the role${r.adminRole ? ` (role: ${r.adminRole.name})` : ''}`,
                `تحددها خانة isSuperAdmin وليس الدور${r.adminRole ? ` (الدور: ${r.adminRole.name})` : ''}`
              )}>
                <i />{this.tx('Super admin', 'مسؤول أعلى')}
              </span>
              : r.adminRole
                ? <span className="tag"><i />{r.adminRole.name}</span>
                : <span className="muted">{this.tx('No role', 'بلا دور')}</span>}
          </span>
        )
      },
      {
        key: 'priv', label: this.tx('Privileges', 'الصلاحيات'), align: 'end', sortable: true,
        sortValue: r => r.privilegeCount || 0,
        render: r => (r.roleId
          ? <span className="num" title={this.tx('Server enforcement is incomplete', 'تطبيق الصلاحيات على الخادم غير مكتمل')}>
            {this.tx(`${r.privilegeCount} of 20`, `${r.privilegeCount} من 20`)}
          </span>
          : <span className="muted">—</span>)
      },
      { key: 'createdAt', label: this.tx('Created', 'تاريخ الإنشاء'), align: 'end', sortable: true, render: r => <span className="mono">{when(r.createdAt)}</span> },
      {
        key: 'act', label: '', align: 'end',
        render: r => {
          // Menyentuh super admin hanya boleh oleh super admin — sama seperti
          // aturan di server, jadi tombolnya tidak menjanjikan yang ditolak.
          const locked = r.isSuperAdmin && !iAmSuper;
          return (
            <span style={{ display: 'inline-flex', gap: 6 }}>
              <button className="btn icon" type="button"
                title={locked ? this.tx('Only a super admin can edit a super admin', 'يمكن للمسؤول الأعلى فقط تعديل مسؤول أعلى') : this.tx('Edit account', 'تعديل الحساب')}
                aria-label={this.tx(`Edit ${r.email}`, `تعديل ${r.email}`)}
                disabled={locked}
                onClick={() => this.openEdit(r)}>
                <Icon name="edit" />
              </button>
              <button className="btn icon" type="button"
                title={r.isYou
                  ? this.tx('You cannot remove your own account', 'لا يمكنك حذف حسابك')
                  : (locked ? this.tx('Only a super admin can remove a super admin', 'يمكن للمسؤول الأعلى فقط حذف مسؤول أعلى') : this.tx('Remove access', 'إزالة الوصول'))}
                aria-label={this.tx(`Remove ${r.email}`, `حذف ${r.email}`)}
                disabled={r.isYou || locked}
                onClick={() => this.setState({ removing: r, notice: null })}>
                <Icon name="trash" />
              </button>
            </span>
          );
        }
      }
    ];
  }

  render() {
    const { rows, roles, me, search, loading, error, notice, editing, removing, busy, tried, form } = this.state;
    const supers = rows.filter(r => r.isSuperAdmin);
    const emptyRole = rows.filter(r => !r.roleId && !r.isSuperAdmin);

    // Beberapa baris saja, dan resolver-nya tidak menerima parameter
    // pencarian — jadi disaring di sini.
    const q = search.trim().toLowerCase();
    const shown = q
      ? rows.filter(r => `${r.email} ${(r.adminRole && r.adminRole.name) || ''}`.toLowerCase().indexOf(q) >= 0)
      : rows;

    return (
      <AdminShell
        current="admins"
        breadcrumb={[this.tx('System', 'النظام'), this.tx('Admin users', 'المستخدمون المسؤولون')]}
        title={this.tx('Admin users', 'المستخدمون المسؤولون')}
        lead={this.tx('Everyone who can sign in to this dashboard.', 'كل من يستطيع تسجيل الدخول إلى لوحة التحكم هذه.')}
        actions={[
          <button className="btn" type="button" key="n" onClick={this.openNew}>
            <Icon name="plus" />{this.tx('Add admin', 'إضافة مسؤول')}
          </button>,
          <a className="btn ghost" href="/siteadmin/admin-users" key="c">
            {this.tx('Open in classic', 'فتح النسخة الكلاسيكية')}
          </a>
        ]}
      >
        {notice && (
          <div className={`notice ${notice.tone}`} role={notice.tone === 'danger' ? 'alert' : 'status'}>
            <span className="ni">{notice.tone === 'danger' ? '!' : '✓'}</span>
            <span className="nt">{notice.text}</span>
            <button className="btn ghost sm" type="button"
              onClick={() => this.setState({ notice: null })}>{this.tx('Dismiss', 'إغلاق')}</button>
          </div>
        )}

        {/* Ini yang paling penting diketahui sebelum membaca kolom peran. */}
        <div className="notice warn">
          <span className="ni">!</span>
          <span className="nt">
            {this.tx(
              'Role enforcement on the server is incomplete. Some newer high-risk actions check privileges, but many existing actions still check only that an admin is signed in. Treat every account here as broad platform access.',
              'تطبيق الأدوار على الخادم غير مكتمل. تتحقق بعض العمليات الحساسة الجديدة من الصلاحيات، لكن كثيراً من العمليات الحالية تتحقق فقط من تسجيل دخول مسؤول. تعامل مع كل حساب هنا على أنه يملك وصولاً واسعاً إلى المنصة.'
            )}
          </span>
        </div>

        {supers.length > 0 && (
          <div className="notice">
            <span className="ni">i</span>
            <span className="nt">
              {this.tx(
                `${supers.map(s => s.email).join(', ')} ${supers.length > 1 ? 'are' : 'is'} flagged as super admin. That flag is separate from the role and controls access to the classic Admin users page${me && !me.isSuperAdmin ? ', including for your account' : ''}.`,
                `${supers.map(s => s.email).join('، ')} ${supers.length > 1 ? 'مُعيّنون' : 'مُعيّن'} كمسؤول أعلى. هذه العلامة منفصلة عن الدور وتتحكم في الوصول إلى صفحة المسؤولين الكلاسيكية${me && !me.isSuperAdmin ? '، بما في ذلك حسابك' : ''}.`
              )}
            </span>
          </div>
        )}

        {emptyRole.length > 0 && (
          <div className="notice">
            <span className="ni">i</span>
            <span className="nt">
              {this.tx(
                `${emptyRole.length} account${emptyRole.length > 1 ? 's have' : ' has'} no role. Server enforcement remains incomplete, but the classic dashboard shows those accounts an empty menu.`,
                `${emptyRole.length} ${emptyRole.length > 1 ? 'حسابات بلا دور' : 'حساب بلا دور'}. تطبيق الصلاحيات على الخادم غير مكتمل، لكن لوحة التحكم الكلاسيكية تعرض لهذه الحسابات قائمة فارغة.`
              )}
            </span>
          </div>
        )}

        {error
          ? <div className="notice danger" role="alert">
            <span className="ni">!</span><span className="nt">{error}</span>
            <button className="btn ghost sm" type="button" onClick={this.load}>{this.tx('Try again', 'إعادة المحاولة')}</button>
          </div>
          : (
            <DataTable
              columns={this.columns()}
              rows={shown}
              count={shown.length}
              page={1}
              perPage={Math.max(shown.length, 1)}
              loading={loading}
              onPage={() => {}}
              onSearch={s => this.setState({ search: s })}
              searchPlaceholder={this.tx('Search email or role', 'ابحث بالبريد أو الدور')}
              emptyText={q ? this.tx('No admin matches', 'لا يوجد مسؤول مطابق') : this.tx('No admin accounts', 'لا توجد حسابات مسؤولين')}
              emptyHint={q
                ? this.tx('Try a different email or clear the search.', 'جرّب بريداً آخر أو امسح البحث.')
                : this.tx('At least one account must exist, or nobody can sign in.', 'يجب أن يوجد حساب واحد على الأقل حتى يمكن تسجيل الدخول.')}
            />
          )}

        {editing && (
          <Modal
            title={editing.id ? this.tx(`Edit ${editing.email}`, `تعديل ${editing.email}`) : this.tx('Add an admin', 'إضافة مسؤول')}
            sub={editing.id
              ? this.tx('Leave the password blank to keep the current one.', 'اترك كلمة المرور فارغة للاحتفاظ بالحالية.')
              : this.tx('They sign in with this email and password straight away.', 'يمكنه تسجيل الدخول بهذا البريد وكلمة المرور فوراً.')}
            icon={editing.id ? 'edit' : 'plus'}
            confirmLabel={editing.id ? this.tx('Save changes', 'حفظ التغييرات') : this.tx('Create account', 'إنشاء الحساب')}
            busy={busy}
            onConfirm={this.save}
            onClose={() => this.setState({ editing: null })}
          >
            <div className="form-grid">
              <Field label={this.tx('Email', 'البريد الإلكتروني')} required span
                hint={this.tx('This is the sign-in name. There is no username.', 'هذا هو اسم تسجيل الدخول، ولا يوجد اسم مستخدم منفصل.')}>
                <input className="inp" type="email" dir="auto" value={form.email}
                  onChange={e => this.set('email', e.target.value)} />
              </Field>

              <Field label={editing.id ? this.tx('New password', 'كلمة المرور الجديدة') : this.tx('Password', 'كلمة المرور')} span
                required={!editing.id}
                hint={editing.id
                  ? this.tx('Blank leaves it unchanged. This is the only password reset path; there is no reset email.', 'تركها فارغة يبقيها كما هي. هذه هي طريقة إعادة التعيين الوحيدة، فلا يوجد بريد لاستعادة كلمة المرور.')
                  : this.tx('At least 8 characters. You must pass it on yourself; nothing is emailed.', '8 أحرف على الأقل. يجب أن تسلّمها بنفسك، فلن يُرسل بريد.')}>
                <input className="inp mono" type="password" autoComplete="new-password"
                  value={form.password}
                  onChange={e => this.set('password', e.target.value)} />
              </Field>

              <Field label={this.tx('Role', 'الدور')} required span
                hint={editing.isYou
                  ? this.tx('You cannot change your own role — ask another admin.', 'لا يمكنك تغيير دورك بنفسك، اطلب من مسؤول آخر.')
                  : this.tx('Controls classic navigation; server enforcement is still incomplete.', 'يتحكم في القائمة الكلاسيكية، ولا يزال تطبيقه على الخادم غير مكتمل.')}>
                <select className="inp" value={form.roleId}
                  disabled={!!editing.isYou}
                  onChange={e => this.set('roleId', e.target.value)}>
                  <option value="">{this.tx('Pick a role…', 'اختر دوراً…')}</option>
                  {roles.map(r => (
                    <option key={r.id} value={String(r.id)}>{r.name}</option>
                  ))}
                </select>
              </Field>
            </div>

            {tried && this.formError() && (
              <div className="notice danger" style={{ marginTop: 12 }}>
                <span className="ni">!</span><span className="nt">{this.formError()}</span>
              </div>
            )}
          </Modal>
        )}

        {removing && (
          <Modal
            title={this.tx(`Remove ${removing.email}?`, `حذف ${removing.email}؟`)}
            sub={this.tx('They lose access to this dashboard immediately.', 'سيفقد الوصول إلى لوحة التحكم فوراً.')}
            icon="trash"
            tone="danger"
            confirmLabel={this.tx('Remove access', 'إزالة الوصول')}
            busy={busy}
            onConfirm={this.remove}
            onClose={() => this.setState({ removing: null })}
          >
            <p>
              {this.tx('The account is deleted, not disabled, and cannot be restored from this dashboard. Existing actions remain in the audit log under its email.',
                'سيُحذف الحساب ولن يُعطّل فقط، ولا يمكن استعادته من لوحة التحكم. تبقى إجراءاته السابقة في سجل التدقيق تحت بريده الإلكتروني.')}
            </p>
          </Modal>
        )}
      </AdminShell>
    );
  }
}

const mapState = state => ({ currentLocale: state && state.intl && state.intl.locale });

export default connect(mapState)(AdminUsers);
